var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 76,
    viewBox: "0 0 114 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_1442)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M56.5946 14.4634V21.5066L64.7969 26.289L64.58 19.1049L56.5946 14.4634Z",
    fill: "url(#paint0_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M56.5938 14.4634V21.5066L48.5348 26.1904V19.1471L56.5938 14.4634Z",
    fill: "url(#paint1_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.1424 55.9127C15.7122 53.1411 17.3247 50.2745 20.9799 48.151C23.7186 46.5592 27.1744 45.6331 30.7422 45.376V47.1368C27.1744 47.3974 23.7186 48.32 20.9799 49.9118C18.0977 51.5881 16.4852 53.7257 16.1424 55.9127Z",
    fill: "url(#paint2_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8747 44.9218L66.5739 35.5931L82.1775 35.7973C83.2688 35.748 84.3566 35.6389 85.4235 35.4663L78.323 39.5936C78.0082 39.7768 78.0082 40.0726 78.3195 40.2522L86.2734 44.8761C83.3563 45.1578 81.7648 45.0909 81.7648 45.0909L66.8747 44.9218Z",
    fill: "url(#paint3_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3257 33.2124C78.0144 33.0293 78.0144 32.737 78.3292 32.5538L85.4297 28.4265V35.4697L83.8172 36.4065L78.3257 33.2124Z",
    fill: "url(#paint4_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M23.0401 39.5338C22.7253 39.7169 22.7253 40.0127 23.0366 40.1923L30.7422 44.6718C27.1744 44.9324 23.7186 45.8551 20.9799 47.4468C14.7678 51.0565 14.453 56.8108 20.0459 60.6001L20.011 67.1186L8.51722 67.1397C-3.1654 59.7126 -2.76665 48.1054 9.67499 40.8755C15.4114 37.5405 22.7427 35.7058 30.235 35.3501L23.0401 39.5338Z",
    fill: "url(#paint5_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0286 39.9246L89.2767 34.5471C90.5919 34.114 91.8301 33.5716 92.9529 32.9201C99.5392 29.0922 99.6302 22.9152 93.1523 19.1506C92.8445 18.971 92.5227 18.802 92.1939 18.64L102.733 18.6224C102.953 18.6224 103.156 18.5696 103.299 18.485C103.446 18.4005 103.534 18.2843 103.537 18.154L103.572 12.0088C103.894 12.1813 104.216 12.3539 104.531 12.537C117.242 19.9254 117.119 32.0186 104.258 39.4915C99.6687 42.1609 94.0687 43.8829 88.1819 44.6612L80.0286 39.9246Z",
    fill: "url(#paint6_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7376 35.2092L47.3164 35.3747L47.6172 44.7035L32.7796 44.5345L24.7381 39.8578L32.7376 35.2092Z",
    fill: "url(#paint7_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1656 20.5169C56.8542 20.3338 56.3471 20.3373 56.0323 20.5204L48.526 24.8837C48.533 24.8274 48.54 24.771 48.5505 24.7076C49.1801 20.3373 52.3841 16.0515 58.1519 12.6989C70.1843 5.70146 89.1668 5.19083 101.969 11.2022L101.934 17.689L89.9713 17.7102C83.5669 15.488 75.0567 16.0128 69.4603 19.2667C66.746 20.8444 65.144 22.82 64.6403 24.8626L57.1656 20.5169Z",
    fill: "url(#paint8_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1367 52.5743C56.8254 52.3912 56.3182 52.3947 56.0034 52.5778L48.7979 56.765C49.1127 56.0853 49.3051 55.3916 49.3611 54.6908L48.5356 26.1903L56.5945 21.5066L64.58 26.1481L65.3984 54.5323C65.3705 55.4057 65.234 56.279 64.9997 57.1454L57.1367 52.5743Z",
    fill: "url(#paint9_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3984 47.5735V54.4019L65.3949 54.5322C65.367 55.4056 65.2305 56.2789 64.9962 57.1452V50.102C65.2131 49.2991 65.339 48.4926 65.3809 47.6827L65.3984 47.5735Z",
    fill: "url(#paint10_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M0.0456905 47.1439C-0.0382576 51.7925 2.77746 56.448 8.51384 60.0964L19.3255 60.0753C19.5529 60.2549 19.7872 60.4275 20.0391 60.6L20.0041 67.1185L8.51035 67.1397C2.74599 63.4737 -0.0732384 58.7899 0.0421886 54.1167L-0.0067749 54.0498V47.1228L0.0456905 47.1439Z",
    fill: "url(#paint11_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M55.9994 45.5309C56.1568 45.4393 56.3596 45.3971 56.5625 45.4006V52.1762L48.7939 56.7649V49.7216L55.9994 45.5309Z",
    fill: "url(#paint12_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0078 60.0752V67.1184L8.51407 67.1396V60.0963L20.0078 60.0752Z",
    fill: "url(#paint13_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9529 32.9237C99.5392 29.0957 99.6302 22.9188 93.1523 19.1541C92.8445 18.9745 92.5227 18.8055 92.1939 18.6435L102.733 18.6259C102.953 18.6259 103.156 18.5731 103.299 18.4886C103.446 18.404 103.534 18.2878 103.537 18.1575L103.572 12.0088C103.894 12.1813 104.216 12.3539 104.531 12.537C117.242 19.9254 117.119 32.0186 104.258 39.4915C99.6687 42.1609 94.0687 43.8829 88.1819 44.6612L80.0286 39.9211L89.2767 34.5471C90.5919 34.1175 91.8301 33.5752 92.9529 32.9237Z",
    fill: "url(#paint14_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0221 32.8814L89.2702 27.5039C90.5854 27.0708 91.8236 26.5284 92.9464 25.8769C99.5327 22.0489 99.6237 15.872 93.1458 12.1074C92.838 11.9278 92.5162 11.7588 92.1874 11.5968L102.726 11.5792C102.947 11.5792 103.149 11.5263 103.293 11.4418C103.44 11.3573 103.527 11.2411 103.531 11.1108L103.566 4.96558C103.887 5.13814 104.209 5.31069 104.524 5.49382C117.232 12.8822 117.113 24.9754 104.251 32.4518C99.6622 35.1212 94.0622 36.8432 88.1754 37.6215L80.0221 32.8814Z",
    fill: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8055 68.0482C21.0259 68.0482 21.2287 67.9954 21.3721 67.9109C21.519 67.8264 21.6065 67.7102 21.61 67.5799L21.6415 61.5438C28.1578 64.8999 38.193 64.7485 44.4681 61.1001C45.5769 60.4556 46.4933 59.7443 47.2278 58.9836L56.5599 53.5603L64.6328 58.2546C63.3351 61.7058 60.3865 64.988 55.7729 67.6714C43.1669 74.9999 22.8412 75.1372 10.0883 68.0658L20.8055 68.0482Z",
    fill: "#9F19AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0437 32.4903L30.2422 28.3066V35.3499L28.5353 36.343L23.0437 33.1489C22.7289 32.9657 22.7289 32.6699 23.0437 32.4903Z",
    fill: "url(#paint15_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7398 32.8145V39.8577L32.7812 44.5344V37.4912L24.7398 32.8145Z",
    fill: "url(#paint16_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0401 32.4903C22.7253 32.6734 22.7253 32.9693 23.0366 33.1489L30.7422 37.6284C27.1744 37.889 23.7186 38.8116 20.9799 40.4034C14.7678 44.0131 14.453 49.7674 20.0459 53.5566L20.011 60.0751L8.51722 60.0963C-3.1654 52.6692 -2.76665 41.0619 9.67499 33.8321C15.4114 30.4971 22.7427 28.6623 30.235 28.3066L23.0401 32.4903Z",
    fill: "url(#paint17_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0221 32.8814L89.2702 27.5039C90.5854 27.0708 91.8236 26.5284 92.9464 25.8769C99.5327 22.0489 99.6237 15.872 93.1458 12.1074C92.838 11.9278 92.5162 11.7588 92.1874 11.5968L102.726 11.5792C102.947 11.5792 103.149 11.5263 103.293 11.4418C103.44 11.3573 103.527 11.2411 103.531 11.1108L103.566 4.96558C103.887 5.13814 104.209 5.31069 104.524 5.49382C117.232 12.8822 117.113 24.9754 104.251 32.4518C99.6622 35.1212 94.0622 36.8432 88.1754 37.6215L80.0221 32.8814Z",
    fill: "url(#paint18_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M23.0401 32.4903C22.7253 32.6734 22.7253 32.9693 23.0366 33.1489L30.7422 37.6284C27.1744 37.889 23.7186 38.8116 20.9799 40.4034C14.7678 44.0131 14.453 49.7674 20.0459 53.5566L20.011 60.0751L8.51722 60.0963C-3.1654 52.6692 -2.76665 41.0619 9.67499 33.8321C15.4114 30.4971 22.7427 28.6623 30.235 28.3066L23.0401 32.4903Z",
    fill: "url(#paint19_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M17.2092 50.8063C14.8797 47.334 16.1389 43.2172 20.9799 40.4035C23.7186 38.8117 27.1744 37.8855 30.7422 37.6284V44.6717C27.1744 44.9323 23.7186 45.8549 20.9799 47.4467C19.2799 48.4363 18.0277 49.5843 17.2092 50.8063Z",
    fill: "url(#paint20_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3164 35.3745L47.6172 44.7033V37.6601L47.3164 28.3313V35.3745Z",
    fill: "url(#paint21_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M32.7376 28.1658L47.3164 28.3313L47.6172 37.66L32.7796 37.491L24.7381 32.8143L32.7376 28.1658Z",
    fill: "url(#paint22_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M32.7796 37.4912V44.5344L47.6172 44.7035V37.6602L32.7796 37.4912Z",
    fill: "url(#paint23_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.6172 45.4078V47.1686L32.7796 46.9996V45.2388L47.6172 45.4078Z",
    fill: "url(#paint24_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M86.0841 36.403L88.1793 37.6215C94.0626 36.8432 99.6626 35.1212 104.255 32.4518C110.786 28.6555 114.024 23.6654 113.972 18.7104L114 18.6858V26.1692L113.969 26.2044C113.825 31.0114 110.586 35.8114 104.255 39.4915C99.6661 42.1609 94.0661 43.883 88.1793 44.6612L80.026 39.9211L86.0841 36.403Z",
    fill: "url(#paint25_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M89.9672 10.6704V17.7136L101.93 17.689V10.6458L89.9672 10.6704Z",
    fill: "url(#paint26_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M80.0221 32.8814L89.2702 27.5039C90.5854 27.0708 91.8236 26.5284 92.9464 25.8769C99.5327 22.0489 99.6237 15.872 93.1458 12.1074C92.838 11.9278 92.5162 11.7588 92.1874 11.5968L102.726 11.5792C102.947 11.5792 103.149 11.5263 103.293 11.4418C103.44 11.3573 103.527 11.2411 103.531 11.1108L103.566 4.96558C103.887 5.13814 104.209 5.31069 104.524 5.49382C117.232 12.8822 117.113 24.9754 104.251 32.4518C99.6622 35.1212 94.0622 36.8432 88.1754 37.6215L80.0221 32.8814Z",
    fill: "url(#paint27_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3513 21.4713C97.2009 21.7882 97.026 22.1052 96.8197 22.4151C96.1726 21.4502 95.2422 20.5345 94.0389 19.714L92.1921 18.6399V11.5967C92.5209 11.7587 92.8392 11.9277 93.1505 12.1073C97.4807 14.6253 98.8694 18.2208 97.3513 21.4713Z",
    fill: "url(#paint28_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1797 44.6612V37.6179L80.0263 32.8813V39.9246L88.1797 44.6612Z",
    fill: "url(#paint29_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M66.879 37.8785L81.7726 38.0476C81.7726 38.0476 83.3641 38.118 86.2812 37.8328V44.876C83.3641 45.1577 81.7726 45.0908 81.7726 45.0908L66.879 44.9218L66.5782 35.593L66.8056 35.5965L66.879 37.8785Z",
    fill: "url(#paint30_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.1793 45.4852C94.0626 44.7069 99.6626 42.9848 104.255 40.3155C110.786 36.5192 114.024 31.5325 113.972 26.5741L114 26.553V34.0364L113.969 28.7892C113.825 33.5962 110.586 38.3962 104.255 42.0763C99.6661 44.7456 94.0661 46.4677 88.1793 47.246V45.4852Z",
    fill: "url(#paint31_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.879 45.7457L81.7726 45.9148C81.7726 45.9148 83.3641 45.9852 86.2812 45.7V47.4608C83.3641 47.7425 81.7726 47.6756 81.7726 47.6756L66.879 47.5065V45.7457Z",
    fill: "url(#paint32_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M66.8747 37.8784L66.5739 28.5496L82.1775 28.7539C83.2688 28.7046 84.3566 28.5954 85.4235 28.4229L78.323 32.5502C78.0082 32.7333 78.0082 33.0291 78.3195 33.2087L86.2734 37.8326C83.3563 38.1143 81.7648 38.0474 81.7648 38.0474L66.8747 37.8784Z",
    fill: "url(#paint33_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M78.1508 32.7088C78.0319 32.5398 78.0913 32.339 78.3292 32.2017L84.6217 28.5427C84.891 28.5075 85.1604 28.4688 85.4297 28.4265L78.3292 32.5538C78.2487 32.5996 78.1893 32.6525 78.1508 32.7088Z",
    fill: "url(#paint34_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M66.8747 37.5264L81.7683 37.6954C81.7683 37.6954 83.1709 37.7553 85.7523 37.5299L86.2734 37.8327C83.3563 38.1145 81.7648 38.0476 81.7648 38.0476L66.8712 37.8785V37.5264H66.8747Z",
    fill: "url(#paint35_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M57.1656 13.4737C56.8542 13.2906 56.3471 13.2941 56.0323 13.4772L48.526 17.8405C48.533 17.7841 48.54 17.7278 48.5505 17.6644C49.1801 13.2941 52.3841 9.00828 58.1519 5.6557C70.1843 -1.34175 89.1668 -1.85239 101.969 4.15901L101.934 10.6458L89.9713 10.667C83.5669 8.44482 75.0567 8.96954 69.4603 12.2235C66.746 13.8012 65.144 15.7768 64.6403 17.8194L57.1656 13.4737Z",
    fill: "url(#paint36_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6406 17.8195L57.1658 13.4738C56.8545 13.2907 56.3474 13.2942 56.0326 13.4773L48.5263 17.8406C48.5333 17.7843 48.5403 17.7279 48.5508 17.6645C48.5578 17.6152 48.5683 17.5659 48.5788 17.5202L56.0326 13.1886C56.3474 13.0054 56.8545 13.0054 57.1658 13.185L64.6406 17.5307V17.8195Z",
    fill: "url(#paint37_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6403 17.5235C65.144 15.4809 66.746 13.5053 69.4603 11.9276C75.0567 8.67365 83.5669 8.14893 89.9713 10.3711L101.934 10.3535L101.969 4.15894L101.934 10.6458L89.9713 10.6669C83.5669 8.44474 75.0567 8.96946 69.4603 12.2234C66.746 13.8011 65.144 15.7767 64.6403 17.8193V17.5235Z",
    fill: "url(#paint38_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.6378 25.6549C65.1414 23.6123 66.7434 21.6367 69.4577 20.059C75.0542 16.8051 83.5643 16.2803 89.9688 18.5025V20.2633C83.5643 18.0412 75.0542 18.5659 69.4577 21.8198C66.7434 23.3975 65.1414 25.3732 64.6378 27.4157V25.6549Z",
    fill: "url(#paint39_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M20.8055 61.005C21.0259 61.005 21.2287 60.9522 21.3721 60.8677C21.519 60.7832 21.6065 60.6669 21.61 60.5366L21.6415 54.5006C28.1578 57.8567 38.193 57.7053 44.4681 54.0569C45.5769 53.4124 46.4933 52.7011 47.2278 51.9404L56.5599 46.5171L64.6328 51.2114C63.3351 54.6626 60.3865 57.9447 55.7729 60.6282C43.1669 67.9567 22.8412 68.094 10.0883 61.0226L20.8055 61.005Z",
    fill: "url(#paint40_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.598 60.3958C60.0997 57.7792 63.0133 54.5851 64.3565 51.229L64.6328 51.391C63.3351 54.8422 60.3865 58.1243 55.7729 60.8078C43.1669 68.1363 22.8412 68.2736 10.0883 61.2022H10.6899C23.4813 67.8475 43.2473 67.5763 55.598 60.3958Z",
    fill: "url(#paint41_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7729 60.6316C60.3865 57.9482 63.3351 54.666 64.6328 51.2148V58.2581C63.3351 61.7093 60.3865 64.9914 55.7729 67.6749C43.1669 75.0034 22.8412 75.1407 10.0883 68.0693V61.0261C22.8412 68.094 43.1704 67.9566 55.7729 60.6316Z",
    fill: "url(#paint42_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.0474768 55.1557C-0.0364704 59.8042 2.77925 64.4598 8.51562 68.1082V69.869C2.75127 66.203 -0.0679502 61.5192 0.0474768 56.846L-0.00149727 56.7791V55.1345L0.0474768 55.1557Z",
    fill: "url(#paint43_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.7729 68.6434C60.3865 65.9599 63.3351 62.6777 64.6328 59.2266V60.9874C63.3351 64.4386 60.3865 67.7207 55.7729 70.4042C43.1669 77.7327 22.8412 77.87 10.0883 70.7986V69.0378C22.8412 76.1057 43.1704 75.9683 55.7729 68.6434Z",
    fill: "url(#paint44_linear_2164_1442)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.1474 19.8548C94.5255 20.6542 95.6028 21.5663 96.3828 22.5418C96.1869 22.827 95.9631 23.1123 95.7182 23.3905C95.0257 22.6932 94.1687 22.0382 93.1439 21.443C92.8361 21.2634 92.5143 21.0944 92.1855 20.9324V19.3477C92.5178 19.5061 92.8396 19.6752 93.1474 19.8548Z",
    fill: "url(#paint45_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M56.0306 13.4772C56.188 13.3857 56.3874 13.3469 56.5938 13.3469V20.369L48.5523 24.7077L48.5278 17.8405L56.0306 13.4772Z",
    fill: "url(#paint46_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M57.1144 13.4772C56.957 13.3857 56.7577 13.3469 56.5513 13.3469V20.369L64.5927 24.7077L64.6172 17.8405L57.1144 13.4772Z",
    fill: "url(#paint47_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M97.9346 18.9357C97.8821 16.5128 96.2906 14.1111 93.1426 12.2833C92.8348 12.1037 92.513 11.9347 92.1842 11.7727H92.7614C92.8873 11.8396 93.0202 11.903 93.1426 11.977C96.4236 13.8822 98.015 16.4107 97.9346 18.9357Z",
    fill: "url(#paint48_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1758 37.4875C94.059 36.7092 99.659 34.9871 104.252 32.3178C110.632 28.6095 113.871 23.7673 113.968 18.925C114.003 23.8694 110.764 28.8419 104.248 32.6277C99.659 35.297 94.059 37.0191 88.1723 37.7974L80.0189 33.0573L80.2847 32.9023L88.1758 37.4875Z",
    fill: "url(#paint49_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6172 37.6602L32.9964 37.3221L24.7381 32.8145L32.7621 37.6743L47.6172 37.6602Z",
    fill: "url(#paint50_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M49.3594 47.6476C49.2999 48.3448 49.111 49.0421 48.7962 49.7218C48.7962 49.7218 49.132 48.7991 49.132 46.6439C49.132 43.5343 48.5374 26.1939 48.5374 26.1939V19.1506L49.3594 47.6476Z",
    fill: "url(#paint51_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M16.0794 47.3024C15.9955 44.7492 17.6255 42.1784 20.9799 40.2274C23.5857 38.7131 26.8421 37.8116 30.221 37.5017L30.7422 37.8046C27.1744 38.0652 23.7186 38.9878 20.9799 40.5796C17.7829 42.439 16.1494 44.8689 16.0794 47.3024Z",
    fill: "url(#paint52_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M22.861 32.8215C22.7421 32.6525 22.8016 32.4518 23.0394 32.3144L29.5593 28.5252C29.7832 28.5111 30.0105 28.497 30.2344 28.4829L23.0359 32.6666C22.959 32.7124 22.8995 32.7652 22.861 32.8215Z",
    fill: "url(#paint53_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M8.51466 59.9205L20.0084 59.8993L20.0434 53.733H20.0469L20.0119 60.2515L8.51816 60.2726C2.90071 56.7017 0.0849876 52.1623 0.0500107 47.6089C0.221401 52.0426 3.04411 56.4411 8.51466 59.9205Z",
    fill: "url(#paint54_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M57.1332 45.531C56.8219 45.3478 56.3147 45.3514 55.9999 45.5345L48.7944 49.7217C49.1162 48.8589 49.3051 47.9644 49.2911 47.0981L48.5356 19.1505L56.5945 14.4668L64.58 19.1083L65.3984 47.4925C65.3705 48.3659 65.234 49.2392 64.9997 50.1056L57.1332 45.531Z",
    fill: "url(#paint55_linear_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0034 45.2669C56.3182 45.0838 56.8254 45.0838 57.1367 45.2634L65.0032 49.8345C65.2305 48.9963 65.36 48.1511 65.3949 47.306L65.3984 47.4891C65.3705 48.3624 65.234 49.2358 64.9997 50.1021L57.1332 45.5311C56.8219 45.3479 56.3147 45.3515 55.9999 45.5346L48.7944 49.7218C48.8469 49.6056 48.8924 49.4894 48.9378 49.3731L56.0034 45.2669Z",
    fill: "url(#paint56_radial_2164_1442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5742 28.5498V35.593L66.875 44.9218V37.8786L66.5742 28.5498Z",
    fill: "url(#paint57_linear_2164_1442)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2164_1442",
    x1: 65.6392,
    y1: 15.3738,
    x2: 54.1351,
    y2: 26.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2164_1442",
    x1: 59.5049,
    y1: 15.8028,
    x2: 42.3264,
    y2: 26.8482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B127B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#D140BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2164_1442",
    x1: 35.2018,
    y1: 50.644,
    x2: 8.44465,
    y2: 50.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#8B11AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7207B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2164_1442",
    x1: 86.2753,
    y1: 40.2846,
    x2: 66.5754,
    y2: 40.2846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2164_1442",
    x1: 81.931,
    y1: 28.8888,
    x2: 81.3106,
    y2: 48.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2164_1442",
    x1: 30.7425,
    y1: 51.2439,
    x2: 0.0417229,
    y2: 51.2439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2164_1442",
    x1: 113.983,
    y1: 28.336,
    x2: 80.0291,
    y2: 28.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2164_1442",
    x1: 47.6164,
    y1: 39.9559,
    x2: 24.7368,
    y2: 39.9559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2164_1442",
    x1: 100.447,
    y1: 15.9622,
    x2: 47.6363,
    y2: 15.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1789,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#B227B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2164_1442",
    x1: 56.5526,
    y1: 42.0635,
    x2: 50.1468,
    y2: 53.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B127B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#D140BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2164_1442",
    x1: 68.7111,
    y1: 51.3663,
    x2: 63.875,
    y2: 52.7139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B127B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#D140BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2164_1442",
    x1: -6.2398,
    y1: 57.1314,
    x2: 46.725,
    y2: 57.1314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2164_1442",
    x1: 48.7422,
    y1: 39.5047,
    x2: 56.2791,
    y2: 61.3696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B127B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#D140BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2164_1442",
    x1: 20.3894,
    y1: 49.8867,
    x2: 9.33486,
    y2: 74.3058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#671AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2164_1442",
    x1: 113.983,
    y1: 28.336,
    x2: 80.0291,
    y2: 28.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2164_1442",
    x1: 26.4152,
    y1: 30.5301,
    x2: 41.4611,
    y2: 44.2507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#671AB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2164_1442",
    x1: 30.1342,
    y1: 35.4759,
    x2: 22.7929,
    y2: 52.3434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2164_1442",
    x1: 30.7425,
    y1: 44.2004,
    x2: 0.0417229,
    y2: 44.2004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    stopColor: "#975CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2164_1442",
    x1: 113.976,
    y1: 21.2927,
    x2: 80.0226,
    y2: 21.2927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    stopColor: "#7733DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7943,
    stopColor: "#975CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A56EF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2164_1442",
    x1: -2.34846,
    y1: 17.4613,
    x2: 24.7229,
    y2: 51.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2164_1442",
    x1: 35.2022,
    y1: 44.2179,
    x2: 8.44262,
    y2: 44.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#8B11AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7207B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2164_1442",
    x1: 47.6164,
    y1: 36.5171,
    x2: 47.3169,
    y2: 36.5171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2164_1442",
    x1: 32.4034,
    y1: 6.13641,
    x2: 37.9861,
    y2: 43.2784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2164_1442",
    x1: 50.5756,
    y1: 31.2969,
    x2: 32.0955,
    y2: 48.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2164_1442",
    x1: 48.171,
    y1: 38.6743,
    x2: 33.9731,
    y2: 51.9031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2164_1442",
    x1: 95.5327,
    y1: 25.5384,
    x2: 105.442,
    y2: 50.4078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2164_1442",
    x1: 98.2219,
    y1: 9.49256,
    x2: 86.0806,
    y2: 34.1963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2164_1442",
    x1: 69.6593,
    y1: 0.658077,
    x2: 109.219,
    y2: 32.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2164_1442",
    x1: 98.0493,
    y1: 12.2098,
    x2: 87.5522,
    y2: 26.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2164_1442",
    x1: 88.0388,
    y1: 36.5762,
    x2: 68.5643,
    y2: 47.2932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2164_1442",
    x1: 80.1957,
    y1: 29.8987,
    x2: 70.8151,
    y2: 55.3011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2164_1442",
    x1: 99.2024,
    y1: 32.0956,
    x2: 106.09,
    y2: 49.3823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2164_1442",
    x1: 79.1693,
    y1: 39.494,
    x2: 73.2658,
    y2: 55.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2164_1442",
    x1: 73.2632,
    y1: 14.5652,
    x2: 77.0735,
    y2: 38.7684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B0AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8005B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.0509 26.5223) rotate(180) scale(5.96478 6.00541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.9243 37.6534) rotate(180) scale(5.86331 5.90326)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2164_1442",
    x1: 66.6858,
    y1: -14.1826,
    x2: 84.5655,
    y2: 37.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9359 10.4404) rotate(180) scale(8.4345 8.49196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.0854 8.99996) rotate(180) scale(9.663 9.72882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2164_1442",
    x1: 89.2468,
    y1: 22.2848,
    x2: 64.2165,
    y2: 22.2848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1789,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#B227B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2164_1442",
    x1: 32.9087,
    y1: 42.2995,
    x2: 44.3579,
    y2: 77.3525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5927 59.4325) rotate(180) scale(16.3183 16.4295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2164_1442",
    x1: 10.3168,
    y1: 62.2422,
    x2: 68.8691,
    y2: 62.2422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1789,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#B227B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2164_1442",
    x1: -2.65083,
    y1: 62.5019,
    x2: 19.8547,
    y2: 62.5019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2164_1442",
    x1: 10.3168,
    y1: 67.6127,
    x2: 68.8691,
    y2: 67.6127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1789,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#B227B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2164_1442",
    x1: 94.8653,
    y1: 20.1633,
    x2: 92.2523,
    y2: 23.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E05B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F19AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2164_1442",
    x1: 49.1043,
    y1: 8.83866,
    x2: 54.7913,
    y2: 25.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2164_1442",
    x1: 64.2593,
    y1: 13.9497,
    x2: 55.3712,
    y2: 26.0197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6455,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2164_1442",
    x1: 84.7334,
    y1: 6.596,
    x2: 99.3934,
    y2: 18.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0354,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1789,
    stopColor: "#AE25B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    stopColor: "#D744BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4899,
    stopColor: "#DC48C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#B227B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.9967 28.3598) rotate(180) scale(13.7102 13.8036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1587 40.9968) rotate(180) scale(8.26713 8.32345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2164_1442",
    x1: 49.8559,
    y1: 34.2448,
    x2: 32.3176,
    y2: 36.9816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B127B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#D140BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.4099 42.4022) rotate(180) scale(6.22313 6.26552)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5369 29.3595) rotate(180) scale(3.03783 3.05852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.046 53.9394) rotate(180) scale(8.3523 8.40919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2164_1442",
    x1: 30.4449,
    y1: 7.99167,
    x2: 69.886,
    y2: 47.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B127B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#D140BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_2164_1442",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.4114 45.1008) rotate(180) scale(5.02905 5.06331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2164_1442",
    x1: 66.8751,
    y1: 36.7367,
    x2: 65.3207,
    y2: 36.7367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_1442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 76,
    fill: "white",
    transform: "matrix(-1 0 0 1 114 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.589a87dcb8478f2afce59652502d56a1.svg";
export { ForwardRef as ReactComponent };